module.exports = __webpack_public_path__ + "src/assets/images/text_icon.e952019da65b38c18b9f5f67557cdab5.png";